import useSWR, { SWRResponse } from 'swr';
import type { AxiosError } from 'axios';
import { Agent, IndividualRank } from '../../../providers/api/dtos';
import { getIndividualRank } from '../../../providers/api/individual-rank/inividualRankProvider';

export const INDIVIDUAL_RANK_V1_RID = '/v1/rankings/individual/:agentId';

export default function useIndividualRank(agentId?: Agent['id']): SWRResponse<IndividualRank[], AxiosError> {
  return useSWR(agentId ? [INDIVIDUAL_RANK_V1_RID, agentId] : null, () => getIndividualRank(agentId!));
}
